import {
	initiatePasswordRecovery,
	InitiatePasswordRecoveryPayload,
} from "@/api/forgot-password";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";
import { InitiatePasswordRecoveryResponse } from "./schema";

export const useInitiatePasswordRecoveryLink = (
	options?: MutationOptionsWithoutFn<
		InitiatePasswordRecoveryResponse,
		InitiatePasswordRecoveryPayload
	>,
) => {
	return useMutation({
		mutationFn: initiatePasswordRecovery,
		...options,
	});
};
